import type { RundownPermission } from '~shared/types'
import { useRundownAccess } from './use-rundown-access'

type UseRundownPermissionProps = {
  permission: RundownPermission
}

/**
 * Hook to check if the current user has a specific rundown permission.
 *
 * @deprecated Use `useRundownAccess` instead, which provides loading state
 * via `isReady` and allows checking multiple permissions.
 *
 * @example
 *   // Migration:
 *   // Before:
 *   const canEdit = useRundownPermission({
 *     permission: RundownPermission.EDIT,
 *   })
 *
 *   // After:
 *   const { hasPermission } = useRundownAccess()
 *   const canEdit = hasPermission(RundownPermission.EDIT)
 *
 * @param props.permission - The RundownPermission flag to check
 *
 * @returns true if the user has the permission, false otherwise
 *
 * @see {@link useRundownAccess} for the recommended replacement
 */
export const useRundownPermission = ({
  permission,
}: UseRundownPermissionProps): boolean => {
  const { hasPermission } = useRundownAccess()
  return hasPermission(permission)
}
